module.exports = __webpack_public_path__ + "static/img/green2.afdb516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/green2.png
// module id = S08Y
// module chunks = 0